import React, { Fragment } from 'react';
import { List, ListItem, ListItemText, } from '@material-ui/core';

import { Filters } from './../services/Filters';

const _filters = new Filters();

export const EventDetail = (props) => {

  const { description, location } = props;

  return (
    <Fragment>
      <List>
        <ListItem>
          <ListItemText>
            {description ?
              <Fragment>
                <strong>Description:</strong>
                <div>
                  {_filters.nl2br(description)}
                </div>
              </Fragment>
              : null
            }
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>
            {location ?
              <Fragment>
                <strong>Location:</strong>
                <div>
                  {_filters.nl2br(location)}
                </div>
              </Fragment>
              : null
            }
          </ListItemText>
        </ListItem>
      </List>
    </Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/components/EventDetail.js